<template>
  <div :class="classModifiers" v-if="showNewsFeed">
    <template v-if="!collapsible">
      <div class="news-feed__header" v-if="showTitle">
        <div class="news-feed__header-title">News Feed</div>
      </div>
      <div class="news-feed__line"></div>
      <div :class="contentClassModifiers">
        <div v-for="item in items" class="news-feed__item">
          <news-feed-item :data="item"></news-feed-item>
        </div>
      </div>
      <div v-show="showMoreButton" @click="loadMore" class="news-feed__more-button">More News</div>
    </template>
    <template v-else>
      <collapsible-panel
        @toggle="$emit('toggle-news')"
        :noPadding="true"
        :darkHeader="true"
        :canClose="false"
        :isOpen="isOpen"
        theme="small-header"
        :key="isOpen"
      >
        <template v-slot:title>
          <div class="news-feed__collapsible-title">
            <span class="news-feed__collapsible-title-text">News Feed</span>
          </div>
        </template>
        <div class="news-feed__collapsible-content">
          <div :class="contentClassModifiers">
            <div v-for="item in items" class="news-feed__item">
              <news-feed-item :data="item"></news-feed-item>
            </div>
          </div>
          <div v-show="showMoreButton" @click="loadMore" class="news-feed__more-button">
            More News
          </div>
        </div>
      </collapsible-panel>
    </template>
  </div>
</template>

<script src="./news-feed.js"></script>
<style src="./news-feed.scss" lang="scss"></style>
